import { useNavigate, useParams } from "react-router-dom";
import { Button, Grid2 as Grid } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DoneIcon from "@mui/icons-material/Done";
import React from "react";
import { useRemittanceComplete } from "../../hooks/useRemittanceComplete";
import { Footer } from "../../components/Footer";
import { LoadingButton } from "../../components/LoadingButton";

interface Props {
  children: React.ReactNode;
  showComplete?: boolean;
  onComplete?(): void;
}

export function WithFooter({ children, showComplete = false, onComplete }: Props) {
  const { supplierId, invoiceId } = useParams<{ supplierId: string; invoiceId: string }>();
  const { complete, isLoading } = useRemittanceComplete(invoiceId);
  const navigate = useNavigate();
  const onBackClick = () => {
    navigate(`/payables/${supplierId}`);
  };
  const onCompleteClick = async () => {
    try {
      await complete();
      onComplete?.();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      {children}
      <Footer>
        <Grid size="grow">
          <Button variant="outlined" fullWidth={true} startIcon={<ArrowBackIcon />} onClick={onBackClick}>
            Back
          </Button>
        </Grid>
        {showComplete && (
          <Grid size="grow">
            <LoadingButton
              onClick={onCompleteClick}
              variant="contained"
              fullWidth={true}
              loading={isLoading}
              loadingPosition="end"
              endIcon={<DoneIcon />}
              disabled={isLoading}
            >
              Complete
            </LoadingButton>
          </Grid>
        )}
      </Footer>
    </>
  );
}
